var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-table",
    {
      staticClass: "tab-resume",
      attrs: { data: _vm.tabResume },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(props) {
            return [
              _c(
                "sc-table-column",
                {
                  attrs: {
                    field: "description",
                    label: "Motivo",
                    centered: false,
                    sortable: false
                  }
                },
                [
                  _c(
                    "span",
                    {
                      class: { "tab-resume__column-child": props.row.isChild }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.description) +
                          "\n      "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    field: "total_values.total_item_quantity",
                    label: "CT-e"
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(props.row.total_values.total_item_quantity) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  staticClass: "has-text-right",
                  attrs: {
                    field: "total_values.total_invoice_cost",
                    label: "Valor da fatura"
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("currency")(
                          props.row.total_values.total_invoice_cost
                        )
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  staticClass: "has-text-right",
                  attrs: {
                    field: "total_values.total_cte_cost",
                    label: "Valor CT-e"
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("currency")(
                          props.row.total_values.total_cte_cost
                        )
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  staticClass: "has-text-right",
                  attrs: {
                    field: "total_values.total_quote_cost",
                    label: "Valor esperado Intelipost"
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("currency")(
                          props.row.total_values.total_quote_cost
                        )
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  staticClass: "has-text-right",
                  attrs: {
                    field: "total_values.total_divergence_cost",
                    label: "Variação"
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("currency")(
                          props.row.total_values.total_divergence_cost
                        )
                      ) +
                      "\n    "
                  )
                ]
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "template",
        { attrs: { slot: "empty" }, slot: "empty" },
        [_c("sc-table-empty")],
        1
      ),
      _vm._v(" "),
      _vm.tabResume.length > 0
        ? _c("template", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c("th", [
              _c("div", { staticClass: "th-wrap has-text-left" }, [
                _vm._v("\n        Total geral\n      ")
              ])
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "has-text-centered" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.invoice.total_values.total_item_quantity) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "has-text-right" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm._f("currency")(
                      _vm.invoice.total_values.total_invoice_cost
                    )
                  ) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "has-text-right" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm._f("currency")(_vm.invoice.total_values.total_cte_cost)
                  ) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "has-text-right" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm._f("currency")(
                      _vm.invoice.total_values.total_quote_cost
                    )
                  ) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "has-text-right" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm._f("currency")(
                      _vm.invoice.total_values.total_divergence_cost
                    )
                  ) +
                  "\n    "
              )
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b71054c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b71054c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/pages/invoice-audit-detail/components/tab-resume/TabInvoiceAuditDetailResume.vue
// module id = null
// module chunks = 